import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { FilterData } from '../components/wizard/steps/who/helpers/filter-template-data';
import {
  AttributeCodes,
  AvailableLanguage,
  CampaignAdhocList,
  CampaignEstimationIdentifier,
  CountryRegion,
  CouponSet,
  EstimationResult,
  GenericActivityTypes,
  MemberCategory,
  MemberClub,
  MemberSource,
  MemberStatus,
  MTV,
  OptOutFlags,
  PointSource,
  Region,
  ReportedCampaign,
  RFM,
  Store,
  Tier,
} from '../models/wizard.model';

export const HelpTextChanged = createAction('[Wizard- Who]: Toggle Help Text Status');

export const AdvancedHelpTextChanged = createAction(
  '[Wizard- Who]: Toggle Advanced Help Text Status',
);

export const TargetGroupFiltersPanelChanged = createAction(
  '[Wizard- Who]: Target Group Panel Filters Changed',
);

export const AdvancedFilterConfigurationPanelChanged = createAction(
  '[Wizard- Who]: Advanced Filter Configuration Panel Changed',
);

export const AdditionalRecipientsPanelChanged = createAction(
  '[Wizard- Who]: Additional Recipients Panel Changed',
);

export const OpenBasicFiltersModal = createAction('[Wizard- Who]: Open Basic Filters Modal');

export const CloseBasicFiltersModal = createAction('[Wizard- Who]: Close Basic Filters Modal');

export const ExecuteInitialCalls = createAction(
  '[Wizard- Who]: Execute Init Calls',
  props<{ selectionTarget: string }>(),
);

export const SelectionsByTargetSuccess = createAction(
  '[Wizard- Who]: Selections By Target Success',
  props<{ selections: string[] }>(),
);

export const SelectionsByTargetFailure = createAction(
  '[Wizard- Who]: Selections By Target Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const MemberCategoriesSuccess = createAction(
  '[Wizard- Who]: Categories Success',
  props<{ categories: MemberCategory[] }>(),
);

export const MemberCategoriesFailure = createAction(
  '[Wizard- Who]: Categories Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const SiriusAccountsInit = createAction('[Wizard- Who]: Sirius Accounts Init');

export const SiriusAccountsSuccess = createAction(
  '[Wizard- Who]: Sirius Accounts Success',
  props<{ siriusAccounts: any }>(),
);

export const SiriusAccountsFailure = createAction(
  '[Wizard- Who]: Sirius Accounts Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const SocialMediaProvidersInit = createAction('[Wizard- Who]: Social Media Providers Init');

export const SocialMediaProvidersSuccess = createAction(
  '[Wizard- Who]: Social Media Providers Success',
  props<{ socialMediaProviders: string[] }>(),
);

export const SocialMediaProvidersFailure = createAction(
  '[Wizard- Who]: Social Media Providers Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const StoresSuccess = createAction(
  '[Wizard- Who]: Stores Success',
  props<{ stores: Store[] }>(),
);

export const StoresFailure = createAction(
  '[Wizard- Who]: Stores Failure',
  props<{ error: HttpErrorResponse }>(),
);
export const CampaignAdhocListsSuccess = createAction(
  '[Wizard- Who]: Campaign Adhoc Lists Success',
  props<{ campaignAdhocLists: CampaignAdhocList[] }>(),
);

export const CampaignAdhocListsFailure = createAction(
  '[Wizard- Who]: Campaign Adhoc Lists Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const CampaignAdhocListChanged = createAction(
  '[Wizard- Who]: Campaign Adhoc List Changed',
  props<{ adhocList: CampaignAdhocList }>(),
);

export const CampaignAdhocListNameChanged = createAction(
  '[Wizard- Who]: Campaign Adhoc List Name Changed',
  props<{ adhocListName: string }>(),
);

export const ControlGroupPercentageChanged = createAction(
  '[Wizard- Who]: Control Group Percentage Changed',
  props<{ controlGroupPercentage: number }>(),
);

export const RecipientLimitChanged = createAction(
  '[Wizard- Who]: Recipient Limit Changed',
  props<{ recipientLimit: number }>(),
);

export const CampaignAdhocListNameCleared = createAction(
  '[Wizard- Who]: Campaign Adhoc List Name Cleared',
);

export const OpenPreviewListModal = createAction('[Wizard- Who]: Open Preview List Modal');

export const ClosePreviewListModal = createAction('[Wizard- Who]: Close Preview List Modal');

export const FilterSelected = createAction(
  '[Wizard- Who] filterSelected',
  props<{ selectedFilter: FilterData }>(),
);

export const RemoveFilter = createAction('[Wizard- Who] Remove Filter', props<{ index: any }>());

export const FilterUpdated = createAction(
  '[Wizard- Who] Filter Updated',
  props<{ index: number; changes: Partial<FilterData> }>(),
);

export const EstimationRunInit = createAction('[Wizard- Who] Estimation Run Init');

export const EstimationRunSuccess = createAction(
  '[Wizard- Who] Estimation Run Success',
  props<{ campaignEstimationIdentifier: CampaignEstimationIdentifier }>(),
);
export const EstimationRunFailure = createAction(
  '[Wizard- Who] Estimation Run Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const EstimationResultSuccess = createAction(
  '[Wizard- Who] Estimation Result Success',
  props<{ estimationResult: EstimationResult }>(),
);
export const EstimationResultFailure = createAction(
  '[Wizard- Who] Estimation Result Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const ShowFilterInfo = createAction('[Wizard- Who] Show Filter Info');

export const OpenFilterConfirmationModal = createAction(
  '[Wizard- Who] Open Filter Confirmation Modal',
  props<{ source: string }>(),
);

export const CloseFilterConfirmationModal = createAction(
  '[Wizard- Who] Close Filter Confirmation Modal',
);

export const ClearEstimationResult = createAction('[Wizard Who] Clear Estimation Result');

export const CancelEstimationPolling = createAction('[Wizard- Who] Cancel Estimation Polling');

export const OpenTargetSample = createAction('[Wizard- Who] Open Target Sample');

export const CloseTargetSample = createAction('[Wizard- Who] Close Target Sample');

export const RefreshTargetSample = createAction('[Wizard- Who] Refresh Target Sample');

export const SearchCampaignsInit = createAction(
  '[Wizard- Who] Search Campaign Init',
  props<{ payload: any }>(),
);

export const SearchCampaignsSuccess = createAction(
  '[Wizard- Who] Search Campaign Success',
  props<{ res: any }>(),
);

export const SearchCampaignsFailure = createAction(
  '[Wizard- Who] Search Campaign Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const GetOptOutFlagsInit = createAction('[Wizard- Who] Get OptOut Flags Init');

export const GetOptOutFlagsSuccess = createAction(
  '[Wizard- Who] Get OptOut Flags Success',
  props<{ optOutFlags: OptOutFlags }>(),
);

export const GetOptOutFlagsFailure = createAction(
  '[Wizard- Who] Get OptOut Flags Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const GetMemberStatusesInit = createAction('[Wizard- Who] Get Member Statuses Init');

export const GetMemberStatusesSuccess = createAction(
  '[Wizard- Who] Get Member Statuses Success',
  props<{ memberStatuses: MemberStatus[] }>(),
);

export const GetMemberStatusesFailure = createAction(
  '[Wizard- Who] Get Member Statuses Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCouponSetsInit = createAction('[Wizard- Who] Get CouponSets Init');

export const GetCouponSetsSuccess = createAction(
  '[Wizard- Who] Get CouponSets Success',
  props<{ couponSets: CouponSet[] }>(),
);

export const GetCouponSetsFailure = createAction(
  '[Wizard- Who] Get CouponSets Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCouponSetAttributesInit = createAction(
  '[Wizard- Who] Get CouponSetAttributes Init',
);

export const GetCouponSetAttributesSuccess = createAction(
  '[Wizard- Who] Get CouponSetAttributes Success',
  props<{ attributes: AttributeCodes[] }>(),
);

export const GetCouponSetAttributesFailure = createAction(
  '[Wizard- Who] Get CouponSetAttributes Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getPointSourcesInit = createAction('[Wizard Who] Get PointSources Init');

export const getPointSourcesSuccess = createAction(
  '[Wizard Who] Get PointSources Success',
  props<{ pointSources: PointSource[] }>(),
);

export const getPointSourcesFailure = createAction(
  '[Wizard Who] Get PointSources Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getMemberSourcesInit = createAction('[Wizard Who] Get MemberSources Init');

export const getMemberSourcesSuccess = createAction(
  '[Wizard Who] Get MemberSources Success',
  props<{ memberSources: MemberSource[] }>(),
);

export const getMemberSourcesFailure = createAction(
  '[Wizard Who] Get MemberSources Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getAvailableLanguagesInit = createAction('[Wizard Who] Get Available Languages Init');

export const getAvailableLanguagesSuccess = createAction(
  '[Wizard Who] Get Available Languages Success',
  props<{ availableLanguages: AvailableLanguage[] }>(),
);

export const getAvailableLanguagesFailure = createAction(
  '[Wizard Who] Get Available Languages Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getMemberClubsInit = createAction('[Wizard Who] Get Member Clubs Init');

export const getMemberClubsSuccess = createAction(
  '[Wizard Who] Get Member Clubs Success',
  props<{ memberClubs: MemberClub[] }>(),
);

export const getMemberClubsFailure = createAction(
  '[Wizard Who] Get Member Clubs Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getTagsInit = createAction('[Wizard Who] Get Tags Init');

export const getTagsSuccess = createAction(
  '[Wizard Who] Get Tags Success',
  props<{ tags: any[] }>(),
);

export const getTagsFailure = createAction(
  '[Wizard Who] Get Tags Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getStoresInit = createAction('[Wizard- Who]: Get Stores Init');

export const getStoresSuccess = createAction(
  '[Wizard- Who]: Get Stores Success',
  props<{ stores: Store[] }>(),
);

export const getStoresFailure = createAction(
  '[Wizard- Who]: Get Stores Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getCommunicationChannelsInit = createAction(
  '[Wizard- Who]: Get CommunicationChannels Init',
);

export const getCommunicationChannelsSuccess = createAction(
  '[Wizard- Who]: Get CommunicationChannels Success',
  props<{ communicationChannels: string[] }>(),
);

export const getCommunicationChannelsFailure = createAction(
  '[Wizard- Who]: Get CommunicationChannels Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCouponSetsFastInit = createAction('[Wizard- Who] Get CouponSets Fast Init');

export const GetCouponSetsFastSuccess = createAction(
  '[Wizard- Who] Get CouponSets Fast Success',
  props<{ couponSets: CouponSet[] }>(),
);

export const GetCouponSetsFastFailure = createAction(
  '[Wizard- Who] Get CouponSets Fast Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getTiersInit = createAction('[Wizard- Who]: Get Tiers Init');

export const getTiersSuccess = createAction(
  '[Wizard- Who]: Get Tiers Success',
  props<{ tiers: Tier[] }>(),
);

export const getTiersFailure = createAction(
  '[Wizard- Who]: Get Tiers Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getRFMInit = createAction('[Wizard- Who]: Get RFM Init');

export const getRFMSuccess = createAction(
  '[Wizard- Who]: Get RFM Success',
  props<{ rfm: RFM[] }>(),
);

export const getRFMFailure = createAction(
  '[Wizard- Who]: Get RFM Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const CardTypesInit = createAction('[Wizard- Who]: Get CardTypes Init');

export const CardTypesSuccess = createAction(
  '[Wizard- Who]: CardTypes Success',
  props<{ cardTypes: string[] }>(),
);

export const CardTypesFailure = createAction(
  '[Wizard- Who]: CardTypes Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getCountriesInit = createAction('[Wizard- Who]: Get Countries Init');

export const getCountriesSuccess = createAction(
  '[Wizard- Who]: Get Countries Success',
  props<{ countries: CountryRegion[] }>(),
);

export const getCountriesFailure = createAction(
  '[Wizard- Who]: Get Countries Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getRegionsInit = createAction(
  '[Wizard- Who]: Get Regions Init',
  props<{ countryCode: string; lang: string }>(),
);

export const getRegionsSuccess = createAction(
  '[Wizard- Who]: Get Regions Success',
  props<{ regions: Region[] }>(),
);

export const getRegionsFailure = createAction(
  '[Wizard- Who]: Get Regions Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getMTVInit = createAction('[Wizard- Who]: Get MTV Init');

export const getMTVSuccess = createAction(
  '[Wizard- Who]: Get MTV Success',
  props<{ mtv: MTV[] }>(),
);

export const getMTVFailure = createAction(
  '[Wizard- Who]: Get MTV Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getPersonSourcesInit = createAction('[Wizard- Who]: Get Person Sources Init');

export const getPersonSourcesSuccess = createAction(
  '[Wizard- Who]: Get Person Sources Success',
  props<{ personSources: MemberSource[] }>(),
);

export const getPersonSourcesFailure = createAction(
  '[Wizard- Who]: Get Person Sources Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getReportedEmailCampaignsInit = createAction(
  '[Wizard- Who]: Get Reported Email Campaigns Init',
);

export const getReportedEmailCampaignsSuccess = createAction(
  '[Wizard- Who]: Get Reported Email Campaigns Success',
  props<{ reportedEmailCampaigns: ReportedCampaign[] }>(),
);

export const getReportedEmailCampaignsFailure = createAction(
  '[Wizard- Who]: Get Reported Email Campaigns Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getReportedInAppCampaignsInit = createAction(
  '[Wizard- Who]: Get Reported InApp Campaigns Init',
);

export const getReportedInAppCampaignsSuccess = createAction(
  '[Wizard- Who]: Get Reported InApp Campaigns Success',
  props<{ reportedInAppCampaigns: ReportedCampaign[] }>(),
);

export const getReportedInAppCampaignsFailure = createAction(
  '[Wizard- Who]: Get Reported InApp Campaigns Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getReportedPushCampaignsInit = createAction(
  '[Wizard- Who]: Get Reported Push Campaigns Init',
);

export const getReportedPushCampaignsSuccess = createAction(
  '[Wizard- Who]: Get Reported Push Campaigns Success',
  props<{ reportedPushCampaigns: ReportedCampaign[] }>(),
);

export const getReportedPushCampaignsFailure = createAction(
  '[Wizard- Who]: Get Reported Push Campaigns Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getProductCategoryLevelsInit = createAction(
  '[Wizard- Who]: Get Product Category Levels Init',
);
export const getProductCategoryLevelsSuccess = createAction(
  '[Wizard- Who]: Get Product Category Levels Success',
  props<{ levels: string[] }>(),
);
export const getProductCategoryLevelsFailure = createAction(
  '[Wizard- Who]: Get Product Category Levels Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getProductCategoriesInit = createAction(
  '[Wizard- Who]: Get Product Categories Init',
  props<{ level: string; lang: string }>(),
);
export const getProductCategoriesSuccess = createAction(
  '[Wizard- Who]: Get Product Categories Success',
  props<{ categories: { [key: string]: string } }>(),
);
export const getProductCategoriesFailure = createAction(
  '[Wizard- Who]: Get Product Categories Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const getGenericActivityTypesInit = createAction(
  '[Wizard- Who]: Get Generic Activity Types Init',
);
export const getGenericActivityTypesSuccess = createAction(
  '[Wizard- Who]: Get Generic Activity Types Success',
  props<{ data: GenericActivityTypes }>(),
);
export const getGenericActivityTypesFailure = createAction(
  '[Wizard- Who]: Get Generic Activity Types Failure',
  props<{ error: HttpErrorResponse }>(),
);
